import React, {useState} from "react"
import Button from "@material-ui/core/Button"
import {LocalOffer} from "@material-ui/icons"
import {makeStyles} from "@material-ui/core/styles"
import i18n from "../../../../i18nextInitiator"
import SlideCard from "../../SlideCard"
import Grid from "@material-ui/core/Grid"
import PriceFeedbackModal from "./PriceFeedbackModal"
import {priceFeedbackModal} from "../../../../actions/actionCreators"
import {connect} from "react-redux"

/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general")
/**
 * JSS.
 * @type {(props?: any) => ClassNameMap<"priceOffer">}
 */
const useStyles = makeStyles((theme) => ({
	priceOffer: {
		// paddingLeft: 0,
        marginTop:"1rem",
        padding:".8rem"
	},
}))
/**
 * maps state to component props.
 * @param state
 */
const mapStateToProps = (state) => ({...state})
/**
 * Price Feedback
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PriceFeedback = (props) => {
	const classes = useStyles()
	const {invoice: {priceFeedback: {display} = {}} = {}} = props

	return (
		<Grid container justifyContent={"flex-end"}>
			<Button
				fullWidth
				onClick={() => priceFeedbackModal(true)}
				startIcon={<LocalOffer />}
				variant={"outlined"}
				color={"secondary"}
				className={classes.priceOffer}>
				{t("invoice.pre.offer-feedback.title")}
			</Button>

			<SlideCard
				title={t("invoice.pre.offer-feedback.title")}
				show={display}
				close={() => priceFeedbackModal(false)}>
				<PriceFeedbackModal />
			</SlideCard>
		</Grid>
	)
}
export default connect(mapStateToProps)(PriceFeedback)
